import React from 'react';
import Slider from 'react-slick';
import { makeStyles } from '@material-ui/core/styles';
import { dateDayWeeksBefore, dateDayWeeksAfter } from 'utils/dates';

const datas = [
  {
    active: false,
    date: dateDayWeeksBefore(1, 3),
    desc: 'Confirmation of deal terms'
  },
  {
    active: false,
    date: dateDayWeeksBefore(1, 4),
    desc: 'Opening of investors approach'
  },
  {
    active: true,
    date: dateDayWeeksBefore(0, 0),
    desc: 'End of investors approach'
  },
  {
    active: false,
    date: dateDayWeeksAfter(2, 0),
    desc: 'Opening order book'
  },
  {
    active: false,
    date: dateDayWeeksAfter(3, 0),
    desc: 'Closing order book'
  },
  {
    active: false,
    date: dateDayWeeksAfter(3, 0),
    desc: 'Pricing and allocation'
  }
];

const useStyles = makeStyles((theme) => ({
  slider: {
    padding: '20px',
    '& .slick-prev:before, .slick-next:before': {
      color: '#002380'
    },
    '& > button.slick-prev': {
      marginLeft: '15px',
      marginTop: '15px'
    },
    '& > button.slick-next': {
      marginRight: '20px',
      marginTop: '15px'
    },
    '& .slick-slide:not(.slick-active)': {
      opacity: '0.2'
    },
    '& .slick-slide.slick-center': {
      transform: 'scale(1.01)'
    },
    '& .slick-slide.slick-center div#descContainer': {
      background: '#002380',
      color: '#FFF'
    }
  },
  descContainer: {
    border: '1px solid #002380',
    width: '97%',
    marginRight: 10,
    borderRadius: '4px',
    padding: '0.5rem',
    height: 50
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& > h3': {
      color: '#001E41',
      fontSize: '19px',
      fontWeight: 'bold'
    },
    '& > p': {
      color: '#002380',
      fontSize: '13px',
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  },
  desc: {
    fontSize: 14
  },
  date: {
    color: '#001E41',
    marginBottom: '15px'
  }
}));

const SlideCalendar = () => {
  const classes = useStyles();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true
  };

  return (
    <>
      <div className={classes.header}>
        <h3>Key Milestones</h3>
        <p>See detailed schedule</p>
      </div>
      <Slider className={classes.slider} {...settings}>
        {datas.map((data) => (
          <div key={Math.random()}>
            <h6 className={classes.date}>{data.date}</h6>
            <div className={classes.descContainer} id="descContainer">
              <p className={classes.desc}>{data.desc}</p>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default SlideCalendar;
